import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { UserDetails } from 'src/app/models/user-details.model';
import { CommonService } from 'src/app/services/Common-function/common.service';
import { FormsService } from 'src/app/services/Forms/forms.service';
import { UserService } from 'src/app/services/user-service/user.service';
import { Ga4trackingService } from 'src/app/services/ga4Tracking/ga4tracking.service';
import moment from 'moment';
import { BrowserStorageService } from 'src/app/services/browser-storage/browser-storage.service';


@Component({
  selector: 'ipm-aadhar-verify',
  templateUrl: './aadhar-verify.component.html',
  styleUrls: ['./aadhar-verify.component.scss']
})
export class AadharVerifyComponent implements OnInit, OnChanges {
  @Input({required : false}) currentUserData: UserDetails;
  @Input({required : true}) isInitialBoolean: boolean = false;
  aadharIndentification: string = "adult";
  guardianRequired: boolean = false;
  accordionArray: Array<any> = [
    {
      type:"aadhar",
      header: {
        mainHeading: "Aadhar Card",
        subHeading: "No input required. Verify instantly through DigiLocker."
      },
      isOpened: false,
      isHide: false,
      isDisabled: false,
      isVerified: false
    },
    {
      type:"passport",
      header: {
        mainHeading: "Passport",
        subHeading: "Verify using your Passport details."
      },
      isOpened: false,
      isHide: true,
      isDisabled: false,
      isVerified: false
    }
  ];
isAccepted: boolean = false;
passportForm: FormGroup = new FormGroup({});
isLoadingAddahar: boolean = false;
@ViewChild('identityWarningBannerDialog', {static :  false}) identityWarningBannerRef : TemplateRef<any>;
@Output() updateUserDataEvent: EventEmitter<any> = new EventEmitter();
constructor(public commonService: CommonService,
public formService: FormsService,
private ga4TrackingService: Ga4trackingService,
private userService: UserService,
private browserService: BrowserStorageService) {}

ngOnInit(): void {
  if (this.currentUserData.hasOwnProperty('aadhaarVerification') && !this.currentUserData.aadhaarVerification.verified) {
      this.getCurrentAadhaarDetails();
    } else if (this.currentUserData?.passportValidation?.verified) {
      this.getPassportDetails();
    }
}

ngOnChanges(changes: SimpleChanges): void {
  if (changes['currentUserData']) {
    if (this.currentUserData?.aadhaarVerification?.verified) {
      this.accordionArray[0].isVerified = true;
    }
    if (this.currentUserData?.aadhaarVerification?.guardianRequired) {
      this.aadharIndentification = "minor";
    }
  }
}

togglePanel(currentIndex: number, isOpened: boolean) {
  this.accordionArray.map((item, index) => {
    if (index === currentIndex) {
      item.isOpened = isOpened;
    } else {
      item.isOpened = false;
    }
  })
  this.onChangeIdentityVerification(this.accordionArray[currentIndex].type, this.accordionArray[currentIndex].isOpened);
}


/**
   * On Change Identity Verification
   * Method
   * @param event 
   * @returns 
   */
  onChangeIdentityVerification(event: any, isOpened: boolean) {
    if (event === "passport" && isOpened) {
      this.createPassportForm()
      return;
    }
    this.deletePassportForm();
  }

  /**
   * Create passport Form
   */
  createPassportForm() {
    // Logic to add passport details
    this.passportForm = new FormGroup({
      'passportNumber' : this.formService.getFormControl(''),
      'countryName' : this.formService.getFormControl('', {
      "name": "India",
      "dialCode": "+91",
      "isoCode": "in"
    }),
      "passportdob" : this.formService.getFormControl('')
    });

    this.passportForm.controls['countryName'].disable();
  }

  /**
   * Delete Passport Form
   */
  deletePassportForm() {
    this.passportForm = new FormGroup({});
  }


  /**
 * open Identity Warning Banner for all users
 */
  openIdentityWarningBanner(type: string) {
  if (this.currentUserData.mobile.isVerified) {
    let classNotifyName =  this.commonService.getClassName('ipm-identity-warning-popup-model');
    let data = {
      popupType: type
    }
    this.commonService.openModel(this.identityWarningBannerRef,data,classNotifyName,true);
    let modelRef: Observable<any> = this.commonService.isMobileDisableClick ? this.commonService.bottomRef.afterDismissed() : this.commonService.modelRef.afterClosed();
    if (modelRef) {
      modelRef.subscribe((res) => {
        this.handleCloseDialog(res, type)
      })
    }
    return;
  }
  this.commonService.showToastErrorMessage("Please verify your mobile number first. After that, you can continue with Aadhaar and passport verification.");
}

  handleCloseDialog(type: string, callingFrom: string) {
    if (type === 'verify') {
      if (callingFrom === "Gaadhar") {
        this.aadharValidation(callingFrom);
      } else if (callingFrom === "aadhar") {
        this.aadharValidation(callingFrom);
      } else {
          this.passportValidation();
      }
    } 
  }

    /**
   * Validate Aadhaar
   * @returns 
   */
  aadharValidation(calling: string = "") {
    this.isLoadingAddahar = true;
      if (calling === "aadhar") {
    // Aadhaar DigiLocker flow starts
    //this.commonService.logEvent('verify_aadhaar_digilocker_initiated');
    let eventName = 'verify_aadhaar_digilocker_initiated';
     this.ga4TrackingService.sendEvent(eventName, {
      event_category: 'aadhaar_verification',
      event_label: 'verify_aadhaar_digilocker_initiated'
    });
  
  } else if (calling === "Gaadhar") {
    // Guardian Aadhaar verification flow starts
    //this.commonService.logEvent('verify_aadhaar_guardian_intiated');
    let eventName = 'verify_aadhaar_guardian_intiated';
    this.ga4TrackingService.sendEvent(eventName, {
      event_category: 'aadhaar_verification',
      event_label: 'aadhaar_guardian_verification_initiated'
    });
  }

    this.userService.aadhaarValidationIntilazation(calling).subscribe((res) => {
      let digiLockerId = res?.client_id;
      let url = res?.url;
      if (url && digiLockerId) {
        this.isLoadingAddahar = true;
        let newWindow: any = window.open(url, 'name','height=500,width=500');
        newWindow?.focus()
        this.userService.aadharCardStatus(digiLockerId, calling).subscribe((res: any) => {
          if (calling === "aadhar") {
            if (res.aadhaar) {
              // add one here (verification aadhar completed)
              let eventName = "aadhar_verification_completed";
              this.ga4TrackingService.sendEvent(eventName, {
                event_category: 'aadhar_verification',
                event_label: 'aadhar_verification_successful'
              });
                this.isLoadingAddahar = false;
                res.aadhaar['verified'] = true;
                res.aadhaar['guardianRequired'] = res.aadhaar?.guardianRequired;
                this.guardianRequired = res.aadhaar?.guardianRequired ? res.aadhaar?.guardianRequired : false;
                if (this.guardianRequired) {
                  this.aadharIndentification = "minor";
                  //click the evernt for the minor
                  let eventType = 'click_aadhaar_minor';
                  this.ga4TrackingService.sendEvent(eventType, {
                    event_category: 'aadhar_verification',
                    event_label: 'aadhar_minor_identified'
                  });
                }
                this.updateUserDetails(res?.aadhaar,  "aadhar");
            }
          } else {
              if (res.guardian) { 

                //guardian verification verification completed
                let eventName = "aadhar_guardian_verification_completed";
                this.ga4TrackingService.sendEvent(eventName, {
                  event_category: 'aadhar_verification',
                  event_label: 'aadhar_guardian_verification_successful'
                });
                this.currentUserData.aadhaarVerification["guardian"] = res.guardian;
                this.currentUserData.aadhaarVerification["guardianVerified"] = res.guardianVerified
                this.updateUserDetails(this.currentUserData.aadhaarVerification,  "aadhar");
              }
          }
        
        },(error) =>{
          this.isLoadingAddahar = false;
          this.commonService.showToastErrorMessage('Aadhar Card verification failed.');
        });
      }
    }, error => {
      this.isLoadingAddahar = false;
      this.commonService.showToastError(error);
    });
  }


  /**
   * Update Aadhaar Details Into the current user data
   * @param aadhaarData 
   */
  updateUserDetails(data: any, type: any) {
    if (data) {
      if (type === 'aadhar') {
        this.currentUserData.aadhaarVerification = data;
      } else if (type === 'passport') {
        this.currentUserData.passportValidation = data;
      }
      let sendData = {
        type: type,
        currentUserData: this.currentUserData
      }
      this.updateUserDataEvent.emit(sendData);
    }
  }

  /**
   * Close Dialog Box
   * @param type 
   */
  closeDialogBox(type: string) {
    this.commonService.closingPopupWithSendData(type);
  }

   /**
     * Validate Passport
     * @returns 
     */
    passportValidation() {
      const dateString = this.passportForm.controls['passportdob'].value;
      const formattedDate = moment(dateString).format("YYYY-MM-DD");
      let data = {
        "fileNumber": this.passportForm.controls['passportNumber'].value,
        "dob": formattedDate
      }
      this.userService.passportValidation(data).subscribe((res) => {
        this.updateUserDetails(res?.passport, "passport");
      }, (error: any) => {
        this.commonService.showToastError(error);
      });
    }


      /**
   * Get Current Aadhaar Details
   */
  getCurrentAadhaarDetails() {
    this.userService.getAadharDetails().subscribe((res) => {
      if (res?.aadhaar) {
        res.aadhaar['verified'] = true;
        this.updateUserDetails(res.aadhaar, "aadhar");
      }
    }, (error) => {
      this.commonService.showToastError(error);
    });
  }

 /*this function is made triggering the events , because no such function exist to track the aadhar identification change */
  onAadharIdentificationChange(event: any) {
    let eventType = event.value === "minor" ? 'click_aadhaar_minor' : 'click_aadhaar_adult';
    this.ga4TrackingService.sendEvent(eventType, {
      event_category: 'aadhar_verification',
      event_label: event.value === "minor" ? 'aadhar_minor_identified' : 'aadhar_adult_identified'
    });
  }

  /**
   * Get Passport Details 
   */
  getPassportDetails() {
     this.userService.getPassportDetails().subscribe((res) => {
       if (res?.passport) {
        res.passport.verified = true;
        this.updateUserDetails(res.passport, "passport");
       }  
     },(error) => {
       this.commonService.showToastError(error);
     });
  }
}

